export const version = '2.64.4';
//# sourceMappingURL=version.js.map